import { Box, Button, Stack, styled } from "@mui/material";

const StyledContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "variant" && prop !== "bgImageSrc",
})(({ theme, variant, bgImageSrc }) => ({
  width: "100%",

  display: "flex",
  position: "relative",

  borderRadius: "12px",

  backgroundSize: "cover",
  backgroundPosition: "center",

  ...(variant === "promotion" && {
    minWidth: 336,
    maxWidth: 380,

    alignItems: "flex-start",
    justifyContent: "flex-start",

    padding: "16px",

    backgroundImage: `url(${bgImageSrc})`,
    "&:before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background:
        "linear-gradient(90deg, #382656 29.03%, rgba(63, 42, 85, 0.00) 83.93%)",
      borderRadius: "12px",
      zIndex: 5,
    },
  }),

  ...(variant === "checkout" && {
    minWidth: 272,
    maxWidth: 528,

    display: "grid",
    gridTemplateColumns: "1fr",
    [theme.breakpoints.up("md")]: {
      gridTemplateColumns: "55% 45%",
      direction: "rtl",
    },
  }),
}));

const StyledImage = styled("img")(({ theme }) => ({
  width: "100%",
  height: 174,

  objectFit: "cover",
  borderRadius: "16px 16px 0px 0px",

  [theme.breakpoints.up("md")]: {
    height: "100%",
    borderRadius: "0px 16px 16px 0px",
  },
}));

const StyledStack = styled(Stack)(({ theme, variant }) => ({
  zIndex: 10,

  color: "white",
  position: "relative",

  gap: "8px",

  ...(variant === "checkout" && {
    padding: "32px 16px 40px 16px",

    textAlign: "left",

    backgroundColor: "#3F2A55",
    borderRadius: "0px 0px 8px 8px",

    [theme.breakpoints.up("md")]: {
      padding: "16px",
      borderRadius: "8px 0px 0px 8px",
    },
  }),

  ...(variant === "promotion" && {
    width: 240,
    padding: 0,
    bgcolor: "transparent",
    borderRadius: 0,
  }),
}));

const StyledButton = styled(Button)(() => ({
  "&:hover": { color: "#FDFDFD !important" },
}));

export { StyledContainer, StyledImage, StyledStack, StyledButton };
